module.exports = __webpack_public_path__ + "img/edit.80f167df.png";